export const NavigationTypes = {
  ShopSection: 'ShopSection',
  AboutTiles: 'AboutTiles',
  JoinTiles: 'JoinTiles',
  InspirationTiles: 'InspirationTiles',
} as const;
